import { MonthPicker } from 'app/components/common/DatePickers';
import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router';
import { GoogleProfileVM } from 'app/stores/ui/agt.googleprofile.ui.store';
import { Icon } from 'app/components/common/Icon';
import { AgtGoogleProfileDetail } from './AgtGoogleProfileDetail';

export const GoogleProfileOptions = observer(() => {
	const { agtGoogleProfileUiStore } = useStore();

	useEffect(() => {
		// Only load if not already loaded (bms array is empty)
		if (agtGoogleProfileUiStore.bms.length === 0) {
			agtGoogleProfileUiStore.load();
		}
	}, [agtGoogleProfileUiStore]);

	const onChange = (value: number) => {
		runInAction(() => {
			agtGoogleProfileUiStore.maxBmCurrent = value;
			agtGoogleProfileUiStore.minBmCurrent = value;
		});
	};

	return (
		<MonthPicker
			value={agtGoogleProfileUiStore.maxBmCurrent}
			opts={agtGoogleProfileUiStore.bmOpts}
			onChange={onChange}
			queryParam="bm"
		/>
	);
});

export const GoogleProfileListe = observer(() => {
	const { berichteUiiStore, agtGoogleProfileUiStore, agenturListUiStore, session } = useStore();
	const location = useLocation();
	const history = useHistory();
	const [hasItems, setHasItems] = useState(false);

	const selectedAgtId = useMemo(() => {
		const params = new URLSearchParams(location.search);
		const id = params.get('detailAgtId');
		return id ? parseInt(id) : null;
	}, [location.search]);

	const tm = useMemo(() => {
		const tm = new TableModel<GoogleProfileVM, number>();
		const cols: ITableColumn<GoogleProfileVM, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});

		if (session.currentUser!.isMulti || session.currentUser!.isAdmin) {
			// cols.push({
			// 	label: 'GP',
			// 	path: 'bew',
			// 	render(row) {
			// 		return <>{row.data.bew >= 25 ? <Icon iconClass="check-circle" faModifier="far" /> : <></>}</>;
			// 	},
			// 	agg: [
			// 		{
			// 			aggType: AggregrationType.sum,
			// 			path: 'gupGpCount',
			// 		},
			// 	],
			// });
			cols.push({
				label: 'Teilhaber',
				path: `agt.thCount`,
				agg: [
					{
						aggType: AggregrationType.sum,
					},
				],
			});
		}

		cols.push({
			label: 'Bewertungen',
			path: `bew`,
		});
		cols.push({
			label: 'Durchschnitt',
			path: `bewAvg`,
		});
		cols.push({
			label: 'Anzahl Bilder',
			path: `imgCount`,
		});



		// cols.push({
		// 	label: 'Anzahl Fragen',
		// 	path: `qCount`,
		// 	// format: formatNum,
		// });
		cols.push({
			label: 'Neue Bewertungen',
			path: `neueBewertung`,
			// format: formatNum,
		});
		cols.push({
			label: 'Selbstbau',
			path: `selbstbau`,
			// format: formatNum,
		});


		cols.push({
			label: 'Rank',
			path: `rank`,
			// format: formatNum,
		});

		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		tm.onRowClick = (row: TableRow<GoogleProfileVM>) => {
			const params = new URLSearchParams(history.location.search);
			params.set('detailAgtId', row.data.agt.agtId.toString());
			history.replace(history.location.pathname + '?' + params.toString());
		};

		return tm;
	}, []);

	useEffect(() => {
		const bm = agtGoogleProfileUiStore.maxBmCurrent;
		if (!bm) return;

		agtGoogleProfileUiStore.loadByBmWithChanges(bm).then((res) => {
			let items = agenturListUiStore.applyFilterOnAgt(res) as GoogleProfileVM[];
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i: GoogleProfileVM) => i.agt.agtId === agtId);
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, agtGoogleProfileUiStore.maxBmCurrent, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged]);

	const handleCloseDetail = useCallback(() => {
		const params = new URLSearchParams(history.location.search);
		params.delete('detailAgtId');
		const newSearch = params.toString();
		history.replace(history.location.pathname + (newSearch ? '?' + newSearch : ''));
	}, [history]);

	return (
		<>
			<div className="table-container">
				<GoogleProfileOptions />
				{!hasItems ? (
					<div className="pad-1rem">Keine Google Unternehmensprofil Teilnahme</div>
				) : (
					<>
						<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
					</>
				)}
			</div>
			{selectedAgtId && (
				<AgtGoogleProfileDetail agtId={selectedAgtId} onClose={handleCloseDetail} />
			)}
		</>
	);
});
